import { Button, Checkbox, Label, Modal, ModalBody } from 'flowbite-react';
import './index.css';
import { useState } from 'react';

interface Props {
  isOpen: boolean
  onClose: (notShowAgain: boolean) => void,
  speLinkRedrect: string
}

export const ExperimentationSpeModal: React.FC<Props> = ({ isOpen, onClose, speLinkRedrect } : Props) => {
  const [notShowAgain, setNotShowAgain] = useState<boolean>(false);

  if (!isOpen) return null

  const redirectToSuperPortal = () => {
      window.open(speLinkRedrect, '_self');
  }

  const handleNotShowAgain = () => {
    setNotShowAgain(!notShowAgain);
  }

  const handleCloseModal = () => {
    onClose(notShowAgain);
  }

  return (
    <Modal show={isOpen} size={'3xl'} onClose={handleCloseModal} popup>
      <ModalBody id="experimentation-spe-modal">
        <div className="flex flex-col md:flex-row w-full pt-5">
          <div className="p-4 pt-10 pb-12 basis-[40%] flex justify-center">
            <img src='/images/experimentation-modal.png' className='h-full w-full max-w-[300px]' />
          </div>
          <div className="text-content basis-[60%] p-2">
            <div>
              <span className="title">Experimente o SuperPortal e volte quando precisar</span>
            </div>
            <div className='pb-4'>
              <p className='text-orientations pt-4'>Use o SuperPortal para acessar todas as soluções da VR que está acostumado no seu dia-a-dia. </p>
              <p className='text-orientations pt-4'>Nos ajude a tornar a VR ainda melhor e mais segura para você!</p>
            </div>
            <div className='container-not-show-again'>
              <Label className='text-not-show-again'>
                <Checkbox
                  name='chk-not-show-again'
                  className='mr-3'
                  onChange={handleNotShowAgain}
                />
                <span>Não exibir novamente</span>
              </Label>
            </div>
            <div className='flex justify-between items-center w-full pt-6'>
              <div>
                <Button
                  type='button'
                  onClick={handleCloseModal}
                  className='btn btn-secondary bg-white border-primary-dark text-primary-dark'
                >
                  Fechar
                </Button>
              </div>

              <div>
                <Button
                  type='button'
                  onClick={redirectToSuperPortal}
                  className='btn btn-go-to-spe'
                >
                  Ir para o SuperPortal
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}